import React, { useEffect } from "react";
import {
  ConfirmationModal,
  getZulluTimeFormatExtra,
  IMAGES,
  ParentComponentWithSideBar,
} from "../../assets";
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownButton,
  Row,
  Table,
} from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { useState } from "react";
import { Link } from "react-router-dom";
import { GrSchedulePlay } from "react-icons/gr";
import { MdVideoCall } from "react-icons/md";
import Calendar from "moedim";
import { FaCalendarAlt } from "react-icons/fa";
import { BiCalendar, BiTimeFive } from "react-icons/bi";
import PageContent from "../../assets/genericComponents/AppLayout/components/PageContent";
import CreateMeeting from "../Home/components/meetingComponent/createMeeting";
import UpdateMeeting from "../Home/components/meetingComponent/updateMeeting";
import StartMeeting from "../Home/components/meetingComponent/startMeeting";
import { useDispatch, useSelector } from "react-redux";
import { getAllZoomMeetingAction } from "../../redux/actions";
import { RiDeleteBin6Line } from "react-icons/ri";
import moment from "moment";
import DataTable from "react-data-table-component";
import { useAuth } from "../../Navigation/Auth/ProvideAuth";

const VideoCall = () => {
  const [value, setValue] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [scheduleMeeting, setScheduleMeeting] = useState(false);
  const [reScheduleMeeting, setReScheduleMeeting] = useState(false);
  const [row, setRow] = useState(null);
  const [startMeeting, setStartMeeting] = useState(false);
  const auth = useAuth();
  const zoomRedux = useSelector((state) => state.zoom);

  let dispatch = useDispatch();

  // const VedioCall = [
  //   {
  //     MeetingTime: "Status Update Meetings",
  //     Date: "10.10.2022",
  //     Time: "02:45",
  //     Link: "www.allmeetings.com",
  //   },
  //   {
  //     MeetingTime: "Information Sharing Meetings",
  //     Date: "11.10.2022",
  //     Time: "12:14",
  //     Link: "www.techmeet.com",
  //   },
  //   {
  //     MeetingTime: "Decision Making Meetings",
  //     Date: "13.10.2022",
  //     Time: "09:51",
  //     Link: "www.mentortech.com",
  //   },

  //   {
  //     MeetingTime: "Problem Solving Meetings",
  //     Date: "14.10.2022",
  //     Time: "12:11",
  //     Link: "www.papercroud.com",
  //   },
  //   {
  //     MeetingTime: "Innovation Meetings",
  //     Date: "18.10.2022",
  //     Time: "11:21",
  //     Link: "www.techmeet.com",
  //   },

  //   {
  //     MeetingTime: "Team Building Meetings",
  //     Date: "22.11.2022",
  //     Time: "10:27",
  //     Link: "www.cfplist.com",
  //   },
  //   {
  //     MeetingTime: "Status Update Meetings",
  //     Date: "10.10.2022",
  //     Time: "02:45",
  //     Link: "www.computertech.com",
  //   },
  //   {
  //     MeetingTime: "Information Sharing Meetings",
  //     Date: "11.10.2022",
  //     Time: "12:14",
  //     Link: "www.eventsget.com",
  //   },
  //   {
  //     MeetingTime: "Decision Making Meetings",
  //     Date: "13.10.2022",
  //     Time: "09:51",
  //     Link: "www.papercroud.com",
  //   },
  //   {
  //     MeetingTime: "Status Update Meetings",
  //     Date: "10.10.2022",
  //     Time: "02:45",
  //     Link: "www.cfplist.com",
  //   },
  //   {
  //     MeetingTime: "Information Sharing Meetings",
  //     Date: "11.10.2022",
  //     Time: "12:14",
  //     Link: "www.eventsget.com",
  //   },

  //   {
  //     MeetingTime: "Status Update Meetings",
  //     Date: "10.10.2022",
  //     Time: "02:45",
  //     Link: "www.allconfrences.com",
  //   },
  //   {
  //     MeetingTime: "Information Sharing Meetings",
  //     Date: "11.10.2022",
  //     Time: "12:14",
  //     Link: "www.eventbee.com",
  //   },
  // ];

  // const columns = [
  //   {
  //     name: "Meeting Title",
  //     selector: (row) => row.agenda,
  //     sortable: true,
  //   },
  //   {
  //     name: "Date",
  //     cell: (row) => {
  //       return <>{moment(row.startTime).format(`MM-DD-YYYY  HH:SS A`)}</>;
  //     },
  //     // selector: (row) => row.Date,
  //     sortable: true,
  //   },
  //   {
  //     name: "Meeting Link",
  //     selector: (row) => (
  //       <a href={row.join_url} target="_blank" rel="noreferrer">
  //         {row.join_url}
  //       </a>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Action",
  //     cell: (row) => {
  //       return (
  //         <>
  //           <div className="d-flex justify-content-between">
  //             <div className="mr-3 cursor">
  //               <FiEdit
  //                 onClick={() => {
  //                   setReScheduleMeeting(true);
  //                   setRow(row);
  //                 }}
  //                 size={20}
  //                 style={{ color: "#5E81F4" }}
  //               />
  //             </div>
  //             <div>
  //               <RiDeleteBin6Line
  //                 className="ml-2 cursor"
  //                 onClick={() => {
  //                   setOpen(true);
  //                 }}
  //                 size={20}
  //                 style={{ color: "#E54545" }}
  //               />
  //             </div>
  //           </div>
  //         </>
  //       );
  //     },
  //     sortable: false,
  //     allowOverflow: true,
  //     width: "100px",
  //     center: true,
  //   },
  // ];

  useEffect(() => {
    document.title = "Video Call | Covis";
  }, []);

  // useEffect(() => {
  //   dispatch(
  //     zoomOAuth({
  //       email:
  //         auth.user.email === "irfan@xevensolutions.com"
  //           ? "business@xevensolutions.com"
  //           : auth.user.email,
  //     })
  //   );
  // }, [dispatch]);

  useEffect(() => {
    if (zoomRedux.getUserSuccess && zoomRedux.allMeetingsList.length === 0) {
      dispatch(
        getAllZoomMeetingAction({ page_number: 1, email: zoomRedux.user.email })
      );
    }
  }, [zoomRedux.getUserSuccess]);

  const columns = [
    {
      name: "Meeting Title",
      selector: (row) => row.agenda,
      sortable: true,
    },
    {
      name: "Date",
      cell: (row) => {
        return <>{moment(row.startTime).format(`MM-DD-YYYY  HH:SS A`)}</>;
      },
      // selector: (row) => row.Date,
      sortable: true,
    },
    {
      name: "Meeting Link",
      selector: (row) => (
        <a href={row.join_url} target="_blank" rel="noreferrer">
          {row.join_url}
        </a>
      ),
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between">
              <div className="mr-2 cursor">
                <FiEdit
                  onClick={() => {
                    setReScheduleMeeting(true);
                    setRow(row);
                  }}
                  size={17}
                  style={{ color: "#5E81F4" }}
                />
              </div>
              <div>
                <RiDeleteBin6Line
                  className="cursor"
                  onClick={() => {
                    setOpen(true);
                  }}
                  size={17}
                  style={{ color: "#E54545" }}
                />
              </div>
            </div>
          </>
        );
      },
      sortable: false,
      allowOverflow: true,
      width: "100px",
      center: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        backgroundColor: "rgba(245, 245, 250, 0.4);",
      },
    },
    pagination: {
      pageButtonsStyle: {
        "&:disabled": {
          cursor: "no-drop",
          color: "#fbfbfb",
          opacity: "0.75",
          backgroundColor: "#eee",
        },
      },
    },
  };

  return (
    <>
      {scheduleMeeting && (
        <CreateMeeting
          show={scheduleMeeting}
          onHide={() => setScheduleMeeting(false)}
        />
      )}
      {reScheduleMeeting && (
        <UpdateMeeting
          show={reScheduleMeeting}
          onHide={() => setReScheduleMeeting(false)}
          meetingRecord={row}
        />
      )}
      {startMeeting && (
        <StartMeeting
          show={startMeeting}
          onHide={() => setStartMeeting(false)}
        />
      )}
      <PageContent>
        <div className="">
          <Row className="p-4">
            <Col sm={12} lg={8} md={12} col="12">
              <Card className="border-0">
                <Card.Body className="px-0 pb-1">
                  <Row>
                    <Col lg={12}>
                      <div
                        className="d-flex justify-content-between align-items-center pb-3 
                                             custom-drpdown px-4"
                      >
                        <h6 className="generic-heading-level-2 generic-theme-color">
                          Scheduled Meetings
                        </h6>
                        <DropdownButton
                          align="end"
                          title={
                            <div className="d-flex align-items-center">
                              <BiCalendar className="text-white mr-2" />
                              <span className="f-12 ">New Meeting</span>
                            </div>
                          }
                          id="dropdown-menu-top"
                        >
                          <div>
                            <Dropdown.Item
                              eventKey="1"
                              onClick={() => setStartMeeting(true)}
                              className=" px-3"
                            >
                              <MdVideoCall className="mr-2 f-18" />
                              Start Video Call
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="2" className="px-3">
                              <div onClick={() => setScheduleMeeting(true)}>
                                <span>
                                  <GrSchedulePlay
                                    MdVideoCall
                                    className="mr-2"
                                  />
                                </span>
                                <span>Schedule Meeting</span>
                              </div>
                            </Dropdown.Item>
                          </div>
                        </DropdownButton>
                      </div>
                    </Col>
                  </Row>

                  <div className="mb-2 table-responsive">
                    <DataTable
                      className="dataTables_wrapper"
                      columns={columns}
                      data={zoomRedux?.allMeetingsList?.meetings}
                      customStyles={customStyles}
                      highlightOnHover
                      responsive
                      striped
                      keyField="taskId"
                    />
                  </div>

                  {/* <Table className="Home-Table" striped hover>
                    <thead>
                      <tr>
                        <th className="py-2 pl-4">Meeting Title</th>
                        <th className="py-2">Date</th>
                        <th className="py-2">Time</th>
                        <th className="py-2">Meeting Link</th>
                        <th className="py-2">Actions</th>
                      </tr>
                    </thead>
                    {zoomRedux?.allMeetingsList?.meetings?.length > 0 ? (
                      <tbody className="meeting_table-height">
                        {zoomRedux?.allMeetingsList?.meetings?.map((item) => {
                          return (
                            <tr>
                              <td className="py-2 pl-4">{item?.agenda}</td>
                              <td className="py-2">
                                {moment(item?.startTime).format(`MM-DD-YYYY`)}
                              </td>
                              <td className="py-2">
                                {moment(row?.startTime).format(`HH:SS A`)}
                              </td>
                              <td className="py-2">
                                <Link>{item?.join_url}</Link>
                              </td>
                              <td className="py-2">
                                <FiEdit
                                  onClick={() => {
                                    setReScheduleMeeting(true);
                                    setRow(item);
                                  }}
                                  tbody
                                  tr
                                  className="table-edit-icon generic-theme-color cursor-pointer"
                                />{" "}
                                <BsTrash
                                  className="ml-2 table-trash-icon cursor-pointer"
                                  onClick={() => setOpen(true)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : (
                      <Row>
                        <Col xl={12} lg={12} md={12} sm={12}>
                          <div className="text-center">
                            <h5>No Record Found</h5>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Table> */}
                  {/* <Row className='px-4 mb-3'>
                            <Col>
                                <div className='botton-border d-flex justify-content-center py-1 cursor-pointer' FiEdit onClick={handleShow}>
                                    <span className='generic-theme-color'>Add</span><span className='pl-2'><BsPlusLg className='f-12 generic-theme-color' /></span>
                                </div>
                            </Col>
                        </Row> */}
                  <ConfirmationModal
                    // removeFunc={() => removeEmp(member.userId)}
                    show={open}
                    onHide={() => setOpen(false)}
                  />

                  {/* <Modal show={vedio} onHide={vedioCallSHowClose}>
                    <Modal.Header closeButton className="py-1">
                      <Modal.Title>
                        <div className="d-flex align-items-center">
                          <img
                            src={IMAGES.ZOOMLOGO}
                            className="zoom-metting-logo"
                          />
                          <span className="f-13 pl-2">Covis Meeting</span>
                        </div>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="vedio-Body px-0">
                      <div className="pt-5">
                        <Webcam className="w-100" />
                        <div className="d-flex text-right pt-3 pb-2 px-3 justify-content-end">
                          <button className="f-14 vedioCall-end bg-danger text-white rounded">
                            End
                          </button>
                        </div>
                      </div>
                    </Modal.Body>
                  </Modal> */}
                </Card.Body>
              </Card>
            </Col>
            <Col
              sm={12}
              md={12}
              lg={4}
              col="12"
              className="mt-lg-0 mt-md-4 mt-sm-4 mt-4"
            >
              <Card className="border-0 h-100 px-2 pb-3 pt-1 main-card-calender">
                <Card.Header className="bg-white">
                  <div className="d-flex  align-items-center">
                    <FaCalendarAlt className="generic-theme-color generic-theme-color" />
                    <h6 className="f-14 mt-1 generic-theme-color pl-2">
                      Calender
                    </h6>
                  </div>
                </Card.Header>
                <Card.Body className="p-2">
                  <div className="mb-4">
                    <Calendar
                      className="w-100 calender-size-manage border-0 "
                      value={value}
                      onChange={(d) => setValue(d)}
                    />
                  </div>
                  <hr></hr>

                  <Row>
                    <Col lg="12">
                      <div className="py-2">
                        <h6 className="ml-3 fw9 mt-2 Upcomming-Meetings f-17">
                          Upcoming Meetings
                        </h6>
                      </div>
                    </Col>
                    {zoomRedux?.allMeetingsList?.meetings?.map(
                      (item, index) => {
                        return (
                          <Col lg="12 mt-3">
                            <Row className="meeting-card mx-3">
                              <Col
                                sm={3}
                                lg={12}
                                xl={3}
                                md={3}
                                className="px-1 col-12 mb-2"
                              >
                                <div className="meetinf-date-card py-3">
                                  <h6>
                                    {moment(item.created_at).format("MMM")}
                                  </h6>
                                  <h3>{moment(item.created_at).format("d")}</h3>
                                </div>
                              </Col>

                              <Col
                                sm={7}
                                lg={7}
                                md={7}
                                className="d-flex align-items-center vedio_call-link pr-0 col-8 mt-3 mt-md-0 lgmt-xl-0 mt--0"
                              >
                                <div className="">
                                  <h5 className="f-14 fw9">{item.agenda}</h5>
                                  <div>
                                    <div className="d-flex py-2">
                                      <BiTimeFive className="generic-theme-color f-14" />
                                      <h5 className="f-14 pl-1 ">
                                        {moment(item.start_time).format("LT")}
                                      </h5>
                                    </div>
                                    <div className="f-12">
                                      <Link>{item.join_url}</Link>
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col
                                lg={2}
                                md={2}
                                sm={2}
                                className="px-0 col-4 mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                              >
                                <div className="d-flex justify-content-end">
                                  <div>
                                    <FiEdit
                                      onClick={() => {
                                        setReScheduleMeeting(true);
                                        setRow(item.id);
                                      }}
                                      className="table-edit-icon generic-theme-color cursor-pointer"
                                      size={17}
                                    />
                                  </div>
                                  <div>
                                    <BsTrash
                                      onClick={() => {
                                        setOpen(true);
                                      }}
                                      className="ml-2 table-trash-icon cursor-pointer"
                                      size={17}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                            {/* <Row className="meeting-card mx-3 mt-3">
                            <Col
                              sm={3}
                              lg={12}
                              xl={3}
                              md={3}
                              className="px-1 col-12 mb-2"
                            >
                              <div className="meetinf-date-card py-3">
                                <h6>Nov</h6>
                                <h3>14</h3>
                              </div>
                            </Col>
    
                            <Col
                              sm={7}
                              lg={7}
                              md={7}
                              className="d-flex align-items-center pr-0 col-8 mt-3 mt-md-0 lgmt-xl-0 mt--0"
                            >
                              <div className="">
                                <h5 className="f-14 fw9">Zoom Metting</h5>
                                <div>
                                  <div className="d-flex py-2">
                                    <BiTimeFive className="generic-theme-color f-14" />
                                    <h5 className="f-14 pl-1 ">02:45</h5>
                                  </div>
                                  <div className="f-12">
                                    <Link>us05web.zoom.us/ meeting</Link>
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col
                              lg={2}
                              md={2}
                              sm={2}
                              className="px-0 col-4 mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                            >
                              <div className="d-flex justify-content-end">
                                <div>
                                  <FiEdit className="table-edit-icon generic-theme-color cursor-pointer" />
                                </div>
                                <div>
                                  <BsTrash className="ml-2 table-trash-icon cursor-pointer" />
                                </div>
                              </div>
                            </Col>
                          </Row> */}
                          </Col>
                        );
                      }
                    )}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </PageContent>
      {/* <Modal
        size="md"
        className="p-0"
        aria-labelledby="contained-modal-title-vcenter"
        id="user-welcome-card"
        centered
        show={show}
        onHide={() => handleClose()}
      >
        <Modal.Header
          className="mx-4 pb-3 px-0 d-flex align-items-end"
          closeButton
        >
          <h5 className="generic-heading-level-3">Schedule Meeting</h5>
        </Modal.Header>
        <Modal.Body className="py-0 px-0 px-2">
          <div className="px-3 b7 mt-2">
            <Row>
              <Col lg="12" className="mt-2 mb-2">
                <Form.Group className="">
                  <label className="salary-labels">{"Meeting Title"}</label>
                  <Form.Control type="Text" placeholder="Meeting Title" />
                </Form.Group>
              </Col>

              <Col lg="7 ">
                <Form.Group className="">
                  <label className="salary-labels">{"Date & Time"}</label>
                  <FormControl
                    type="datetime-local"
                    placeholder="Date"
                    className="form_control_date "
                  />
                </Form.Group>
              </Col>
              <Col lg="5 ">
                <Form.Group className="">
                  <label className="salary-labels">{"Time Zone"}</label>
                  <Form.Control as="select" name="bdProjectCategoryId">
                    <option value="0">Pacific Time Zone</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col lg="12">
                <label className="salary-labels">{"Meeting ID"}</label>
                <div className="mb-3">
                  <Form.Check
                    inline
                    label="Generate Automatically"
                    type="radio"
                    name="group1"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-4 f-12"
                    inline
                    name="group1"
                    label="Personal Meeting ID"
                    type="radio"
                  />
                </div>
              </Col>
              <Col lg="5">
                <label className="salary-labels">{"Video"}</label>
                <div className="mb-3 d-flex">
                  <span className="pr-3 f-12 specific-color">Host:</span>
                  <Form.Check
                    inline
                    label="On"
                    type="radio"
                    name="group2"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-2 f-12"
                    inline
                    label="Off"
                    type="radio"
                    name="group2"
                  />
                </div>
              </Col>
              <Col lg="7 align-self-end">
                <div className="mb-3 d-flex">
                  <span className="pr-3 f-12 specific-color">participant:</span>
                  <Form.Check
                    inline
                    label="On"
                    type="radio"
                    name="group3"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-2 f-12"
                    inline
                    label="Off"
                    type="radio"
                    name="group3"
                  />
                </div>
              </Col>
              <Col lg="12">
                <label className="salary-labels">{"Audio"}</label>
                <div className="mb-3 d-flex">
                  <Form.Check
                    inline
                    label="On"
                    name="group4"
                    type="radio"
                    className="f-12"
                  />
                  <span className="pr-3 f-12 specific-color">
                    Computer Audio
                  </span>
                </div>
              </Col>
              <Col lg="12">
                <label className="salary-labels">{"Calender"}</label>
                <div className="mb-2 d-flex">
                  <Form.Check
                    inline
                    label="Google"
                    type="radio"
                    name="group5"
                    className="f-12"
                  />
                  <Form.Check
                    inline
                    label="Outlook"
                    type="radio"
                    name="group5"
                    className="f-12 pl-4"
                  />
                  <Form.Check
                    inline
                    label="Other"
                    type="radio"
                    name="group5"
                    className="f-12 pl-4"
                  />
                </div>
              </Col>
            </Row>

            <Row className="checkbox-size">
              <label className="salary-labels px-3 py-2">
                {"Advance Options"}
              </label>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Allow participant to join anytime"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Mute participant upon entry"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Automatically record meeting on the local computer"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Approve or black entry for users from specific countries/regions"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
            </Row>
            <Row className="py-4">
              <Col lg="12 ">
                <Button
                  type="submit"
                  className="w-100 button-sizes Home-buttons"
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        size="md"
        className="p-0"
        aria-labelledby="contained-modal-title-vcenter"
        id="user-welcome-card"
        centered
        show={editShow}
        onHide={() => editHandleClose()}
      >
        <Modal.Header
          className="mx-4 pb-3 px-0 d-flex align-items-end"
          closeButton
        >
          <h5 className="generic-heading-level-3">Edit Schedule Meeting</h5>
        </Modal.Header>
        <Modal.Body className="py-0 px-0 px-2">
          <div className="px-3 b7 mt-2">
            <Row>
              <Col lg="12" className="mt-2 mb-2">
                <Form.Group className="">
                  <label className="salary-labels">{"Meeting Title"}</label>
                  <Form.Control type="Text" placeholder="Meeting Title" />
                </Form.Group>
              </Col>

              <Col lg="7">
                <Form.Group className="">
                  <label className="salary-labels">{"Date & Time"}</label>
                  <FormControl
                    type="datetime-local"
                    placeholder="Date"
                    className="form_control_date "
                  />
                </Form.Group>
              </Col>
              <Col lg="5 ">
                <Form.Group className="">
                  <label className="salary-labels">{"Time Zone"}</label>
                  <Form.Control as="select" name="bdProjectCategoryId">
                    <option value="0">Pacific Time Zone</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col lg="12">
                <label className="salary-labels">{"Meeting ID"}</label>
                <div className="mb-3">
                  <Form.Check
                    inline
                    label="Generate Automatically"
                    type="radio"
                    name="group1"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-4 f-12"
                    inline
                    name="group1"
                    label="Personal Meeting ID"
                    type="radio"
                  />
                </div>
              </Col>
              <Col lg="5">
                <label className="salary-labels">{"Video"}</label>
                <div className="mb-3 d-flex">
                  <span className="pr-3 f-12 specific-color">Host:</span>
                  <Form.Check
                    inline
                    label="On"
                    type="radio"
                    name="group2"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-2 f-12"
                    inline
                    label="Off"
                    type="radio"
                    name="group2"
                  />
                </div>
              </Col>
              <Col lg="7 align-self-end">
                <div className="mb-3 d-flex">
                  <span className="pr-3 f-12 specific-color">participant:</span>
                  <Form.Check
                    inline
                    label="On"
                    type="radio"
                    name="group3"
                    className="f-12"
                  />
                  <Form.Check
                    className="ml-2 f-12"
                    inline
                    label="Off"
                    type="radio"
                    name="group3"
                  />
                </div>
              </Col>
              <Col lg="12">
                <label className="salary-labels">{"Audio"}</label>
                <div className="mb-3 d-flex">
                  <Form.Check
                    inline
                    label="On"
                    name="group4"
                    type="radio"
                    className="f-12"
                  />
                  <span className="pr-3 f-12 specific-color">
                    Computer Audio
                  </span>
                </div>
              </Col>
              <Col lg="12">
                <label className="salary-labels">{"Calender"}</label>
                <div className="mb-2 d-flex">
                  <Form.Check
                    inline
                    label="Google"
                    type="radio"
                    name="group5"
                    className="f-12"
                  />
                  <Form.Check
                    inline
                    label="Outlook"
                    type="radio"
                    name="group5"
                    className="f-12 pl-4"
                  />
                  <Form.Check
                    inline
                    label="Other"
                    type="radio"
                    name="group5"
                    className="f-12 pl-4"
                  />
                </div>
              </Col>
            </Row>

            <Row className="checkbox-size">
              <label className="salary-labels px-3 py-2">
                {"Advance Options"}
              </label>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Allow participant to join anytime"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Mute participant upon entry"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Automatically record meeting on the local computer"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
              <Col lg="12">
                <Form.Check
                  inline
                  enable
                  label="Approve or black entry for users from specific countries/regions"
                  type="checkbox"
                  className="f-12 check-box-generic"
                />
              </Col>
            </Row>
            <Row className="py-4">
              <Col lg="12 ">
                <Button
                  type="submit"
                  className="w-100 button-sizes Home-buttons"
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default VideoCall;
